export default class ManageTeamsController {

}

